import styled, { css } from 'styled-components';

import {
  colors,
} from '../../theme';

export const Wrapper = styled.div`
  height: 1px;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 9999;

  ${(props) => props.position === 'absolute' && css`
    bottom: auto;
    position: absolute;
    top: 0;
  `}

  ${(props) => props.position === 'fixed-top' && css`
    bottom: auto;
    position: fixed;
    top: 0;
  `}

  ${(props) => props.position === 'fixed-bottom' && css`
    bottom: 0;
    top: auto;
    position: fixed;
  `}
`;

export const Progress = styled.div`
  background: ${colors.BLACK};
  bottom: 0;
  left: 0;
  position: absolute;
  top: 0;
`;



// WEBPACK FOOTER //
// ./src/components/ScrollProgress/style.js